import { hasMarketingConsent } from '@/utils/marketingConsent'

const resource = 'meta_conversions'

export default ($axios, readConsentCookie = () => undefined) => {
  const send = (event, params) =>
    hasMarketingConsent(readConsentCookie())
      ? $axios.$post(`/${resource}/send/${event}`, params).catch(error => {
          if (error.response) throw error
          return null
        })
      : Promise.resolve(null)

  return {
    addToCart(params) {
      return send('add_to_cart', params)
    },
    subscribe(params) {
      return send('subscribe', params)
    },
    contact(params) {
      return send('contact', params)
    },
    search(params) {
      return send('search', params)
    },
    viewContent(params) {
      return send('view_content', params)
    },
    completeRegistration(params) {
      return send('complete_registration', params)
    },
    purchase(params) {
      return send('purchase', params)
    },
    addPaymentInfo(params) {
      return send('add_payment_info', params)
    },
    initiateCheckout(params) {
      return send('initiate_checkout', params)
    },

    getServiceName: name => 'metaConversionService',
  }
}
